import styled, { css } from 'styled-components';
import { ColorClubMatas1 } from 'autogen/design-tokens/tokens';

const Price = styled.div<{ $isClubPrice?: boolean }>`
    grid-area: price;
    text-align: end;

    ${({ $isClubPrice }) =>
        $isClubPrice &&
        css`
            color: ${ColorClubMatas1};
        `}
`;

export default Price;
